
const initialState = {
    route: 'home',
    settingFlag: false,
    loginPermissionFlag: false,
    activeContentTabIndex : 0,
    activeObj:null,
    popupFlag:null,
    currentUser: null
};

export default initialState;
